module.exports = __webpack_public_path__ + "static/avatar-f2a6c2c1b6fb2cc1575f37bdc353fac4.jpg";